import { useMutation, useQuery } from "@tanstack/react-query";
import { apiClient } from "@/shared/lib/api-client";
import { API_ENDPOINTS } from "@/shared/constants/api-endpoints";
import type { FunnelSession, Handler } from "../types";

interface Envelope<T> {
  success: boolean;
  result: T;
}

export function useFunnelSession() {
  return useQuery({
    queryKey: ["funnel", "session"],
    queryFn: async () => {
      const { data } = await apiClient.get<Envelope<FunnelSession>>(
        API_ENDPOINTS.funnel.session,
      );
      return data.result;
    },
  });
}

export function useHandlers() {
  return useQuery({
    queryKey: ["funnel", "handlers"],
    queryFn: async () => {
      const { data } = await apiClient.get<Envelope<Handler[]>>(
        API_ENDPOINTS.funnel.handlers,
      );
      return data.result;
    },
  });
}

/**
 * Claim the visitor's unique mission codename (ai.missioncodenames). Called
 * before the texting-out step so the acceptance SMS carries a real codename.
 * Idempotent per member server-side — a member always gets the same one back.
 */
export function useClaimCodename() {
  return useMutation({
    mutationFn: async (payload: { difficulty?: string } = {}) => {
      const { data } = await apiClient.post<
        Envelope<{ codeName: string; memberId: number; claimed: boolean }>
      >(API_ENDPOINTS.mission.codename, payload);
      return data.result;
    },
  });
}
